import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface InvoiceEditorSideActionsWrapperProps {
  shouldIncreaseWidth: boolean
}

// Spacing.S24 is the same width as the loading spinner icon
export const InvoiceEditorSideActionsWrapper = styled.div<InvoiceEditorSideActionsWrapperProps>`
  ${({ shouldIncreaseWidth }) => !shouldIncreaseWidth && `padding-left: ${Spacing.S24};`}
`
